module.exports = __webpack_public_path__ + "img/trade-12.0b1df86a.png";